<style>
	@import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Device Renewal" title="Enquiry Devices" />

		<div class="container-fluid">
			<div class="card">
				<div class="card-body">
					<div class="col-md-12 project-list filter-sort">
						<div class="row">
							<div class="col-md-10 d-flex">
								<label class="d-flex listing-length"><span>Show</span>
									<select class="form-select" v-model="listing_length" @change="fetchEnquiryDevices()">
										<option value="10">10</option>
										<option value="20">20</option>
										<option value="50">50</option>
										<option value="100">100</option>
										<option value="200">200</option>
									</select>
									<span>entries</span>
								</label>
							</div>
							<div class="col-md-2">
								<input
									type="text"
									class="form-control"
									placeholder="Search IMEI"
									v-model="imei"
									@input="onImeiSearch"
								/>
							</div>
						</div>
					</div>

					<div class="table-responsive product-table">
						<table class="display" id="enquiry-table">
							<thead>
								<tr align="center">
									<th>Sl.No</th>
									<th>IMEI & ICCID</th>
									<th>Dealer</th>
                                    <th>Vehicle Number</th>
                                    <th>Enquired Dealer</th>
									<th>Enquiry On</th>
									<th>Request Status</th>
									<th>Requested On</th>
                                    <th>Action</th>
								</tr>
							</thead>
							<tbody v-if="enquiry_devices.length">
								<tr v-for="(device, index) in enquiry_devices" :key="device.id" align="center">
									<td>{{ (from - 1) + index + 1 }}</td>
									<td>{{ device.imei }} <br> {{ device.iccid }}</td>
									<td>{{ device.dealer_name || '-' }}</td>
                                    <td>{{ device.vehicle_number || '-' }}</td>
                                    <td>{{ device.enquired_dealer_name || '-' }}</td>
									<td><b>{{ device.enquiry_by_name || '-' }}</b> <br>
									    {{ device.enquiry_on ? $filters.formatDateTime(device.enquiry_on) : '-' }}</td>
									<td>
										<span v-if="device.request_status == 1" class="badge rounded-pill bg-success">Requested</span>
										<span v-else-if="device.request_status == 2" class="badge rounded-pill bg-warning">Pending</span>
										<span v-else class="badge rounded-pill bg-secondary">-</span>
									</td>
									<td>{{ device.requested_on ? $filters.formatDateTime(device.requested_on) : '-' }}</td>
									<td>
										<router-link :to="{ name: 'recharge_device', params: { device_id: device.device_id } }" class="btn btn-warning btn-sm mt-2 me-2 mb-2" v-if="device.recharge_status == 2 && device.status != 4">Request Recharge</router-link>
										<router-link :to="{ name: 'update_vehicle_data',params:{imei:device.imei} }" class="btn btn-primary btn-sm me-2 mb-2" v-if="!device.vehicle_number">Add Vehicle</router-link><br>
									</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
									<td colspan="11" align="center">No data available</td>
								</tr>
							</tbody>
						</table>
					</div>

					<caption v-if="enquiry_devices.length" class="float-start mt-2 d-block d-lg-inline">
						Showing {{ from }} to {{ to }} of {{ total }} entries
					</caption>
					<nav aria-label="Page navigation" class="mt-2 float-end">
						<ul class="pagination">
							<li
								class="page-item"
								v-bind:class="[{ disabled: !page.url }, { active: page.active }]"
								v-for="(page, index) in pagination"
								:key="page.label"
							>
								<a
									class="page-link"
									href="#"
									@click.prevent="fetchEnquiryDevices(buildPageUrl(page.url))"
									tabindex="-1"
								>
									<span v-if="index === 0">Prev</span>
									<span v-else-if="index === pagination.length - 1">Next</span>
									<span v-else>{{ page.label }}</span>
								</a>
							</li>
						</ul>
					</nav>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Enquiry Devices",

	data() {
		return {
			token: "",
			imei: "",
			imeiSearchTimer: null,
			listing_length: 10,
			enquiry_devices: [],
			pagination: {},
			from: 0,
			to: 0,
			total: 0,
			active_page_url: null,
		};
	},

	created() {
		this.fetchEnquiryDevices();
	},

	methods: {
		getToken() {
			if (localStorage.getItem("airotrack_staff")) {
				const airotrack_staff = JSON.parse(localStorage.getItem("airotrack_staff"));
				if (airotrack_staff.token) {
					this.token = airotrack_staff.token;
					this.user = airotrack_staff;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
		},

		buildQueryString(pageUrl = null) {
			const params = new URLSearchParams();
			params.append("limit", this.listing_length);
			if (this.imei && this.imei.trim()) {
				params.append("imei", this.imei.trim());
			}
			if (pageUrl) {
				const pageMatch = pageUrl.match(/[?&]page=(\d+)/);
				if (pageMatch) {
					params.append("page", pageMatch[1]);
				}
			}
			return "/staffs/enquiryDevices?" + params.toString();
		},

		buildPageUrl(paginationPageUrl) {
			if (!paginationPageUrl) return this.buildQueryString();
			const pageMatch = paginationPageUrl.match(/[?&]page=(\d+)/);
			const params = new URLSearchParams();
			params.append("limit", this.listing_length);
			if (this.imei && this.imei.trim()) {
				params.append("imei", this.imei.trim());
			}
			if (pageMatch) {
				params.append("page", pageMatch[1]);
			}
			return "/staffs/enquiryDevices?" + params.toString();
		},

		onImeiSearch() {
			if (this.imeiSearchTimer) clearTimeout(this.imeiSearchTimer);
			this.imeiSearchTimer = setTimeout(() => {
				this.fetchEnquiryDevices();
				this.imeiSearchTimer = null;
			}, 400);
		},

		fetchEnquiryDevices(page_url = null) {
			this.getToken();
			const url = this.buildQueryString();
			page_url = page_url || url;
			this.active_page_url = page_url;
			this.$axios
				.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					const responseData = res.data.data;
					if (responseData && responseData.enquiry_devices) {
						this.enquiry_devices = responseData.enquiry_devices.data || [];
						this.pagination = responseData.enquiry_devices.links || [];
						this.from = responseData.enquiry_devices.from ?? 0;
						this.to = responseData.enquiry_devices.to ?? 0;
						this.total = responseData.enquiry_devices.total ?? 0;
					} else {
						this.enquiry_devices = [];
						this.pagination = [];
						this.from = 0;
						this.to = 0;
						this.total = 0;
					}
				})
				.catch((err) => {
					console.log(err);
					this.enquiry_devices = [];
					this.pagination = [];
					this.from = 0;
					this.to = 0;
					this.total = 0;
				});
		},
	},
};
</script>
